import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import subscribe from './subscribe'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { user, app },
})

subscribe(store)

export default store
